<template>  
  <b-container>
    <b-row align-h="center"> 
      <b-col cols="6">
        <b-container v-if="this.$root.token" class="pl-0 pt-0 pb-2 pr-0">
          <b-row align-h="center">
            <b-col>
              <h2>Edit Score Event</h2>
            </b-col>
          </b-row>

          <b-row v-if="loading" align-h="center" class="pb2">
            <b-col>
              <font-awesome-icon icon="spinner" size="lg" spin/>
            </b-col>
          </b-row>

          <b-row align-h="center" class="text-left">
            <b-col>    
              <b-form-group validated 
              id="yearGroup"
              breakpoint="md"
              label="Year"
              label-for="year"
              >
                <b-form-select v-model="year" :options="yearList" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-row align-h="center" class="text-left">
            <b-col>    
              <b-form-group validated 
              id="periodGroup"
              breakpoint="md"
              label="Period"
              label-for="Period"
              >
              <b-form-select v-model="period" :options="periodList"/>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row align-h="center" class="text-left">
            <b-col>    
              <b-form-group validated 
              id="programmeGroup"
              breakpoint="md"
              label="Programme"
              label-for="Programme"
              >
              <b-form-select v-model="programme" :options="programmeList"/>
              </b-form-group>
            </b-col>
          </b-row>        

          <b-row align-h="center" class="text-left">
            <b-col>    
              <b-form-group validated 
              id="customerGroup"
              breakpoint="md"
              label="Customer"
              label-for="Customer"
              >
              <b-form-select v-model="customerId" :options="customerList"/>
              </b-form-group>
            </b-col>
          </b-row>        


          <b-row align-h="center" class="text-left">
            <b-col>
              <b-form-group validated 
                id="staffGroup"
                breakpoint="md"
                label="Number of Staff"
                label-for="number_of_staff"
                
              >
              <b-form-input v-model="number_of_staff" type="number" id="number_of_staff"/>
              </b-form-group>
            </b-col>
          </b-row>        


          <b-row align-h="center" class="text-left">
            <b-col>
              <b-form-group validated 
                id="staffGroup"
                breakpoint="md"
                label="Number of Staff"
                label-for="number_of_units"
                
              >
              <b-form-input v-model="number_of_units" type="number" id="number_of_units"/>
              </b-form-group>
            </b-col>
          </b-row>       


          <b-row align-h="center" class="text-left">
            <b-col>
              <b-form-group validated 
                id="areaGroup"
                breakpoint="md"
                label="Areas"
                label-for="area"
                
              >
                <vue-tags-input :tags="areas" v-model="area" @tags-changed="newTags => areas = newTags" id="area" />
              </b-form-group>
            </b-col>
          </b-row>       

          <b-row align-h="center" class="text-left">
            <b-col>
              <b-form-group validated 
                id="sponsorGroup"
                breakpoint="md"
                label="Sponsor"
                label-for="sponsor"
                
              >
              <b-form-input v-model="sponsor" id="sponsor"/> 
              </b-form-group>
            </b-col>
          </b-row>

          <b-row align-h="center" class="text-left">
            <b-col>
              <b-form-group validated 
                id="sponsorContactGroup"
                breakpoint="md"
                label="Sponsor Contact Number"
                label-for="sponsor_contact_number"
                
              >
              <b-form-input v-model="sponsor_contact_number" id="sponsor_contact_number"/> 
              </b-form-group>
            </b-col>
          </b-row>

          <b-row align-h="center" class="text-left">
            <b-col>
              <b-form-group validated 
                id="gatekeeperGroup"
                breakpoint="md"
                label="Gatekeeper"
                label-for="gatekeeper"
                
              >
                <b-form-input v-model="gatekeeper" id="gatekeeper"/> 
              </b-form-group>
            </b-col>
          </b-row>


          <b-row align-h="center" class="text-left">
            <b-col>
              <b-form-group validated 
                id="gatekeeperContactGroup"
                breakpoint="md"
                label="Gatekeeper Contact Number"
                label-for="gatekeeper_contact_number"
                
              >
                <b-form-input v-model="gatekeeper_contact_number" id="gatekeeper_contact_number"/> 
              </b-form-group>
            </b-col>
          </b-row>

          <b-row align-h="center" class="text-left">
            <b-col>
              <b-form-checkbox
                id="externalPoc"
                v-model="external_poc"
                value="true"
                unchecked-value="false"
                breakpoint="md"
                class="ml-4 mb-3 mt-2"
              >
                External POC
              </b-form-checkbox>
            </b-col>
          </b-row>        

          <b-row align-h="center" class="text-left">
            <b-col>
              <b-form-group validated 
                id="accreditationsGroup"
                breakpoint="md"
                label="Accreditations"
                label-for="accreditations"
                
              >
                <wysiwyg v-model="accreditations" id="accreditations"/>   
              </b-form-group>
            </b-col>
          </b-row>

          <b-row align-h="center" class="text-left">
            <b-col>
              <b-form-group validated 
                id="customizationGroup"
                breakpoint="md"
                label="Customisation"
                label-for="customization"
                
              >
                <wysiwyg v-model="customization" id="customization"/>   
              </b-form-group>
            </b-col>
          </b-row>

          <b-row v-if="saving" class="text-left">
            <b-col>
              <font-awesome-icon icon="spinner" size="lg" spin/>
            </b-col>
          </b-row>

          <b-row>
            <b-col>
              <b-alert :show="!!message"  variant="success">{{ message }}</b-alert>      
            </b-col>
          </b-row>

          <b-row>
            <b-col class="text-left">
              <b-button variant="success" @click="save()" :disabled="!customerId">Save</b-button>
            </b-col>
            <b-col class="text-right">
              <b-button @click="showScoringEvents()" >Show Scoring Events</b-button>
            </b-col>
          </b-row>

        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import {industries, countries, regions} from '@/services/constants';
import * as _ from 'lodash';
import * as API from '@/services/API';
import VueTagsInput from '@johmun/vue-tags-input';


export default {
  name: "EditScoringEvent",
  components: {
    VueTagsInput
  },
  data: function() {
    return {
      survey_run_id: null,
      customerList: [],
      customerId: null,
      number_of_staff: null,
      number_of_units: null,
      areas: [],
      area: '',      
      year: null,
      years: null,
      yearList: [],
      programme: null,
      programmeList: [],
      sponsor: null,
      sponsor_contact_number: null,
      gatekeeper: null,
      gatekeeper_contact_number: null,
      external_poc: "false",
      accreditations: null,
      customization: null,
      period: null,
      periodList: ['CY','Q1', 'Q2', 'Q3', 'Q4', '1H', '2H', 'FY', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      loading: true,
      saving: false,
      message: ''
    };
  },
  created: function(){
    this.init();
  },
  methods:{    
    showScoringEvents(){
      this.$router.push({name: "Scoring Events"});
    },
    init(){
      const thisYear = new Date().getFullYear();
      this.years = [];
      const startYear = 2009;
      for (let i = 0; i < thisYear - startYear; i++) {
        this.yearList.push(thisYear - i);
      }

      // API.getSurvey 
      this.loading = true;
      return Promise.all([
        API.getCustomers(this.$root.token).then(results => {
          this.customerList = this.customerList.concat(
            results.results.map(i => {
              return {
                value: i.id,
                text: i.name
              }
            })            
          );
        }),
        API.getProgrammes(this.$root.token).then(results => {
          this.programmeList = this.programmeList.concat(
            results.results.map(i => {
              return {
                value: i.id,
                text: i.name,
                template: JSON.parse(i.template)
              }
            })            
          );
        }),
        API.getSurveyRunSummary(this.$route.params.id, this.$root.token).then(result => {
          this.survey_run_id = result.surveyRunId;
          this.year = result.year;
          this.period = result.period;
          this.programme = result.programmeId;
          this.customerId = result.customerId;
          this.number_of_staff = result.number_of_staff;
          this.number_of_units = result.number_of_units;     
          if (result.area) {
            this.areas = this.areas.concat((result.area).split(', ').map(
            value => {
              return {
                text: value
              }
            }));
          } else {
            this.areas = [];
            this.area = '';
          }

          this.sponsor = result.sponsor;
          this.sponsor_contact_number = result.sponsor_contact_number;    
          this.gatekeeper = result.gatekeeper;
          this.gatekeeper_contact_number = result.gatekeeper_contact_number;
          this.external_poc = result.external_poc ? "true" : "false";
          this.accreditations = result.accreditations;
          this.customization = result.customization;
        })
      ]).then(() => {        
        this.loading = false;
      });
    },
    save () {      
      this.saving = true;
      this.message = "Saving ...";
      const body = {
        programme_id: this.programme,
        customer_id: this.customerId,
        year: this.year,
        period: this.period,
        area: (this.areas || []).map(value => value.text).join(', '),
        sponsor: this.sponsor,
        sponsor_contact_number: this.sponsor_contact_number,
        gatekeeper: this.gatekeeper,
        gatekeeper_contact_number: this.gatekeeper_contact_number,
        external_poc: ((this.external_poc === "true") ? true : false),
        accreditations: this.accreditations,
        customization: this.customization,
        number_of_staff: this.number_of_staff,
        number_of_units: this.number_of_units
      }
      Object.keys(body).forEach(field => {
        if (field !== "external_poc") {
          if (!body[field]) delete body[field];
        }
      });
      return API.updateSurveyRun(this.survey_run_id, body, this.$root.token).then(response => {
        this.saving = false;
        this.message = 'Saved!';        
      }).catch(e => {
        this.saving = false;
        this.message = 'DID NOT SAVE - CALL SUPPORT';
      });
    }    
  }



}
</script>



// WEBPACK FOOTER //
// src/views/EditScoringEvent.vue